import React, { useState, useEffect } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  IconButton,
  CircularProgress,
  Avatar,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { GoSearch } from "react-icons/go";
import { Link, useNavigate } from "react-router-dom";
import { axiosInstance } from "../../../axiosInstance";
import { toast } from "react-toastify";
import NoImageFound from "../../../assets/images/No-Image-found.png";

const columns = [
  { id: "profile_picture", label: "PROFILE", minWidth: 160, align: "center" },
  { id: "first_name", label: "FIRST NAME", minWidth: 100, align: "center" },
  { id: "last_name", label: "LAST NAME", minWidth: 170, align: "center" },
  { id: "mobile_no", label: "MOBILE NUMBER", minWidth: 170, align: "center" },
  { id: "email", label: "EMAIL ADDRESS", minWidth: 100, align: "center" },
  { id: "actions", label: "ACTIONS", minWidth: 100, align: "center" },
];

function createData(profile_picture, first_name, last_name, email, mobile_no) {
  return { profile_picture, first_name, last_name, email, mobile_no };
}

const rows = [
  createData("Kiran", "S", "abc@gmail.com"),
  createData("Venkatesh", "V", "abc@gmail.com"),
  createData("Kiran", "S", "abc@gmail.com"),
  createData("Venkatesh", "V", "abc@gmail.com"),
];
export const EditSubUsers = ({ WholesalerUserName, id }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [wholesalerSubUsers, setWholesalerSubUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [toggleModalOpen, setToggleModalOpen] = useState(false);
  const [toggleTarget, setToggleTarget] = useState(null);

  const navigate = useNavigate();

  console.log("Wholesaler Username:", WholesalerUserName);

  const fetchWholesalerSubUsers = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await axiosInstance.get(
        `/admin/wholesaler-subuser/by-username/${WholesalerUserName}/`
      );
      console.log("✅ Wholesaler Sub Users response:", res.data);
      if (res.data.status === "success") {
        setWholesalerSubUsers(res.data.data || []);
      } else {
        setError("Failed to fetch Wholesaler  Sub Users data.");
      }
    } catch (err) {
      console.error("❌ Error fetching Wholesaler Sub Users data:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWholesalerSubUsers();
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleToggleStatus = async () => {
    try {
      const res = await axiosInstance.patch(
        `/admin/wholesaler-subuser/${toggleTarget.wholesalersubuser_id}/`,
        {
          is_active: !toggleTarget.is_active,
        }
      );
      if (res.data.status === "success") {
        toast.success("Status updated successfully");
        fetchWholesalerSubUsers();
        setToggleModalOpen(false);
      } else {
        toast.error("Failed to update status");
      }
    } catch (err) {
      toast.error("Error updating status");
    }
  };

  return (
    <>
      <div style={{ marginTop: "30px" }}>
        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <TableContainer sx={{ maxHeight: 440 }} className="Table-container">
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                      className="table-header"
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center">
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                ) : wholesalerSubUsers.length > 0 ? (
                  wholesalerSubUsers
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow
                        className="table-row"
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={index}
                        sx={{
                          backgroundColor:
                            index % 2 === 1 ? "#E7F0F9" : "white",
                        }}
                      >
                        {columns.map((column) => {
                          const value = row[column.id];
                          return (
                            <TableCell
                              key={column.wholesalersubuser_id}
                              align={column.align}
                              className={`${column.wholesalersubuser_id}-column tableCelldata`}
                              sx={{
                                color:
                                  column.id === "status"
                                    ? value === "Active"
                                      ? "green"
                                      : "red"
                                    : "inherit",
                              }}
                            >
                              {column.id === "actions" ? (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    gap: "8px",
                                  }}
                                >
                                  <IconButton sx={{ color: "black" }}>
                                    <EditIcon
                                      style={{
                                        cursor: "pointer",
                                        fontSize: "18px",
                                      }}
                                      onClick={() => {
                                        localStorage.setItem(
                                          "wholesaler_id",
                                          id
                                        );
                                        navigate(
                                          `/manage-wholesaler-eachsubuser/${row.wholesalersubuser_id}`
                                        );
                                      }}
                                    />
                                  </IconButton>
                                  {/* <IconButton sx={{ color: "black" }}>
                                  <DeleteIcon style={{ fontSize: "18px" }} />
                                </IconButton> */}
                                  <div
                                    className="form-check form-switch"
                                    style={{ marginTop: "5px" }}
                                  >
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id={`toggleSwitch-${row.wholesalersubuser_id}`}
                                      checked={row.is_active}
                                      onChange={() => {
                                        setToggleTarget(row);
                                        setToggleModalOpen(true);
                                      }}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor={`toggleSwitch-${row.wholesalersubuser_id}`}
                                    ></label>
                                  </div>
                                </div>
                              ) : column.id === "profile_picture" ? (
                                <Avatar
                                  src={value}
                                  alt="Profile"
                                  sx={{ width: 40, height: 40, margin: "auto" }}
                                  imgProps={{
                                    onError: (e) => {
                                      e.target.onerror = null;
                                      e.target.src = NoImageFound;
                                    },
                                  }}
                                />
                              ) : value === null ||
                                value === undefined ||
                                value === "" ? (
                                "--"
                              ) : (
                                value
                              )}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    ))
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={columns.length}
                      align="center"
                      style={{ padding: "40px 0" }}
                    >
                      No Data Available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[20, 55, 100]}
            component="div"
            count={wholesalerSubUsers.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </div>

      {/* Toggle Status Modal */}
      {/* Active or InActive Confirmation Modal */}

      <Modal
        show={toggleModalOpen}
        onHide={() => setToggleModalOpen(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="toggle-status-title">Are you sure?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Do you want to {toggleTarget?.is_active ? "INACTIVATE" : "ACTIVATE"}{" "}
            this Wholesaler Sub User?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setToggleModalOpen(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleToggleStatus}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
